// cspell:disable

export const normalizedStateCodes: { [key: string]: string } = {
  alabama: "AL",
  alaska: "AK",
  arizona: "AZ",
  arkansas: "AR",
  california: "CA",
  colorado: "CO",
  connecticut: "CT",
  delaware: "DE",
  florida: "FL",
  georgia: "GA",
  hawaii: "HI",
  idaho: "ID",
  illinois: "IL",
  indiana: "IN",
  iowa: "IA",
  kansas: "KS",
  kentucky: "KY",
  louisiana: "LA",
  maine: "ME",
  maryland: "MD",
  massachusetts: "MA",
  michigan: "MI",
  minnesota: "MN",
  mississippi: "MS",
  missouri: "MO",
  montana: "MT",
  nebraska: "NE",
  nevada: "NV",
  newhampshire: "NH",
  newjersey: "NJ",
  newmexico: "NM",
  newyork: "NY",
  northcarolina: "NC",
  northdakota: "ND",
  ohio: "OH",
  oklahoma: "OK",
  oregon: "OR",
  pennsylvania: "PA",
  rhodeisland: "RI",
  southcarolina: "SC",
  southdakota: "SD",
  tennessee: "TN",
  texas: "TX",
  utah: "UT",
  vermont: "VT",
  virginia: "VA",
  washington: "WA",
  westvirginia: "WV",
  wisconsin: "WI",
  wyoming: "WY",
};

export const normalizedCanadianProvinces: { [key: string]: string } = {
  alberta: "AB",
  britishcolumbia: "BC",
  manitoba: "MB",
  newbrunswick: "NB",
  newfoundlandandlabrador: "NL",
  novascotia: "NS",
  ontario: "ON",
  princeedwardisland: "PE",
  quebec: "QC",
  saskatchewan: "SK",
  yukon: "YT",
  northwestterritories: "NT",
  nunavut: "NU",
};

export const normalizedAustralianStates: { [key: string]: string } = {
  australiancapitalterritory: "ACT",
  newsouthwales: "NSW",
  northernterritory: "NT",
  queensland: "QLD",
  southaustralia: "SA",
  tasmania: "TAS",
  victoria: "VIC",
  westernaustralia: "WA",
};

export function getStateCode(input: string): string {
  // we can combine US states, Canadian Provinces, and Australian states because there's only overlap between state codes and not names.
  // if you add more in the future we may have to pass in the country as well and select from the correct set
  const codes = {
    ...normalizedStateCodes,
    ...normalizedCanadianProvinces,
    ...normalizedAustralianStates,
  };

  // If the input is already a state code, just use that
  const inputUpper = input.toUpperCase();
  if (Object.values(codes).includes(inputUpper)) {
    return inputUpper;
  }

  const cleanedInput = input
    .trim()
    .replace(/[^a-zA-Z]/g, "")
    .toLowerCase();
  const stateCode = codes[cleanedInput];

  return stateCode || "";
}

export function getStateCodeFromZipCode(zipcodeString: string): string | null {
  // Returns null on invalid zip-- else returns state code XX

  // Ensure param is a string to prevent unpredictable parsing results
  if (typeof zipcodeString !== "string") {
    console.log(
      "Must pass the zipcode as a string. -- Otherwise leading zeros could cause your zip code to be parsed outside base 10.",
    );
    return null;
  }

  // Ensure you don't parse codes that start with 0 as octal values
  const zipcode = parseInt(zipcodeString, 10);

  // Code blocks alphabetized by state
  const states = [
    { min: 35_000, max: 36_999, code: "AL", long: "Alabama" },
    { min: 99_500, max: 99_999, code: "AK", long: "Alaska" },
    { min: 85_000, max: 86_999, code: "AZ", long: "Arizona" },
    { min: 71_600, max: 72_999, code: "AR", long: "Arkansas" },
    { min: 90_000, max: 96_699, code: "CA", long: "California" },
    { min: 80_000, max: 81_999, code: "CO", long: "Colorado" },
    { min: 6000, max: 6999, code: "CT", long: "Connecticut" },
    { min: 19_700, max: 19_999, code: "DE", long: "Deleware" },
    { min: 32_000, max: 34_999, code: "FL", long: "Florida" },
    { min: 30_000, max: 31_999, code: "GA", long: "Georgia" },
    { min: 96_700, max: 96_999, code: "HI", long: "Hawaii" },
    { min: 83_200, max: 83_999, code: "ID", long: "Idaho" },
    { min: 60_000, max: 62_999, code: "IL", long: "Illinois" },
    { min: 46_000, max: 47_999, code: "IN", long: "Indiana" },
    { min: 50_000, max: 52_999, code: "IA", long: "Iowa" },
    { min: 66_000, max: 67_999, code: "KS", long: "Kansas" },
    { min: 40_000, max: 42_999, code: "KY", long: "Kentucky" },
    { min: 70_000, max: 71_599, code: "LA", long: "Louisiana" },
    { min: 3900, max: 4999, code: "ME", long: "Maine" },
    { min: 20_600, max: 21_999, code: "MD", long: "Maryland" },
    { min: 1000, max: 2799, code: "MA", long: "Massachusetts" },
    { min: 48_000, max: 49_999, code: "MI", long: "Michigan" },
    { min: 55_000, max: 56_999, code: "MN", long: "Minnesota" },
    { min: 38_600, max: 39_999, code: "MS", long: "Mississippi" },
    { min: 63_000, max: 65_999, code: "MO", long: "Missouri" },
    { min: 59_000, max: 59_999, code: "MT", long: "Montana" },
    { min: 27_000, max: 28_999, code: "NC", long: "North Carolina" },
    { min: 58_000, max: 58_999, code: "ND", long: "North Dakota" },
    { min: 68_000, max: 69_999, code: "NE", long: "Nebraska" },
    { min: 88_900, max: 89_999, code: "NV", long: "Nevada" },
    { min: 3000, max: 3899, code: "NH", long: "New Hampshire" },
    { min: 7000, max: 8999, code: "NJ", long: "New Jersey" },
    { min: 87_000, max: 88_499, code: "NM", long: "New Mexico" },
    { min: 10_000, max: 14_999, code: "NY", long: "New York" },
    { min: 43_000, max: 45_999, code: "OH", long: "Ohio" },
    { min: 73_000, max: 74_999, code: "OK", long: "Oklahoma" },
    { min: 97_000, max: 97_999, code: "OR", long: "Oregon" },
    { min: 15_000, max: 19_699, code: "PA", long: "Pennsylvania" },
    { min: 300, max: 999, code: "PR", long: "Puerto Rico" },
    { min: 2800, max: 2999, code: "RI", long: "Rhode Island" },
    { min: 29_000, max: 29_999, code: "SC", long: "South Carolina" },
    { min: 57_000, max: 57_999, code: "SD", long: "South Dakota" },
    { min: 37_000, max: 38_599, code: "TN", long: "Tennessee" },
    { min: 75_000, max: 79_999, code: "TX", long: "Texas" },
    { min: 88_500, max: 88_599, code: "TX", long: "Texas" },
    { min: 84_000, max: 84_999, code: "UT", long: "Utah" },
    { min: 5000, max: 5999, code: "VT", long: "Vermont" },
    { min: 22_000, max: 24_699, code: "VA", long: "Virgina" },
    { min: 20_000, max: 20_599, code: "DC", long: "Washington DC" },
    { min: 98_000, max: 99_499, code: "WA", long: "Washington" },
    { min: 24_700, max: 26_999, code: "WV", long: "West Virginia" },
    { min: 53_000, max: 54_999, code: "WI", long: "Wisconsin" },
    { min: 82_000, max: 83_199, code: "WY", long: "Wyoming" },
  ];

  const state = states.filter(function (s) {
    return s.min <= zipcode && s.max >= zipcode;
  });

  if (state.length == 0) {
    return null;
  } else if (state.length > 1) {
    console.error("Found two states by zip code");
  }
  return state[0].code;
}
